import { render, staticRenderFns } from "./CustomerUserGroupEditor.vue?vue&type=template&id=4302c400&"
import script from "./CustomerUserGroupEditor.vue?vue&type=script&lang=js&"
export * from "./CustomerUserGroupEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports